// The ONE password rule of CityDigitalTwin, used by every page that sets a password (sign up,
// reset, change) and by the server. Two copies, byte for byte the same:
//   server/utils/passwordRules.js  and  client/src/utils/passwordRules.js
// server/tests/unit/password-rules.test.js fails if they differ. Edit both together.
//
// Why one file: the sign-up page counted "_" as a special character and the server did not, so
// a user who met every rule on the page was refused with "Something went wrong" (prod, 2026-11-03).
//
// A "special character" is anything that is not an English letter or a digit: ! . _ - # a space,
// an accented letter, and so on.

export const PASSWORD_RULES = [
  { id: "length", label: "At least 8 characters", need: "at least 8 characters", test: (p) => p.length >= 8 },
  { id: "uppercase", label: "An uppercase letter (A-Z)", need: "an uppercase letter", test: (p) => /[A-Z]/.test(p) },
  { id: "lowercase", label: "A lowercase letter (a-z)", need: "a lowercase letter", test: (p) => /[a-z]/.test(p) },
  { id: "number", label: "A number (0-9)", need: "a number", test: (p) => /[0-9]/.test(p) },
  { id: "special", label: "A special character, such as ! . _ - #", need: "a special character", test: (p) => /[^A-Za-z0-9]/.test(p) },
];

export const missingPasswordRules = (password) =>
  PASSWORD_RULES.filter((rule) => !rule.test(typeof password === "string" ? password : ""));

// "" when the password meets every rule, else one sentence naming everything it lacks:
// "Your password needs an uppercase letter, a number and a special character."
export const passwordProblem = (password) => {
  const needs = missingPasswordRules(password).map((rule) => rule.need);
  if (!needs.length) return "";
  const list = needs.length === 1 ? needs[0] : `${needs.slice(0, -1).join(", ")} and ${needs[needs.length - 1]}`;
  return `Your password needs ${list}.`;
};
